import { cards } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
              最火爆的娱乐八卦热门爆料，每日最新吃瓜内容一网打尽
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cards.map((card) => (
              <article
                key={card.title}
                className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] bg-background-200 overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg text-foreground-800 line-clamp-2 leading-snug mb-3 group-hover:text-primary-600 transition-colors duration-200">
                    {card.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>
                      <i className="ri-time-line mr-1"></i>
                      {card.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-accent-500"></i>
                      {card.hot}热度
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-700 rounded-lg text-sm font-medium hover:bg-secondary-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看更多热门爆料
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}